/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementSliderSlideIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementSliderSlideIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3ZM13 3L3 3V13H13V3Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5 6.27734C5.5 5.0347 6.50736 4.02734 7.75 4.02734H8.5C9.60457 4.02734 10.5 4.92277 10.5 6.02734H9.5C9.5 5.47506 9.05228 5.02734 8.5 5.02734H7.75C7.05964 5.02734 6.5 5.58699 6.5 6.27734C6.5 6.9677 7.05964 7.52734 7.75 7.52734H8.25C9.49264 7.52734 10.5 8.5347 10.5 9.77734C10.5 11.02 9.49264 12.0273 8.25 12.0273H7.5C6.39543 12.0273 5.5 11.1319 5.5 10.0273H6.5C6.5 10.5796 6.94772 11.0273 7.5 11.0273H8.25C8.94036 11.0273 9.5 10.4677 9.5 9.77734C9.5 9.08699 8.94036 8.52734 8.25 8.52734H7.75C6.50736 8.52734 5.5 7.51998 5.5 6.27734Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementSliderSlideIcon.tags = [
  'slider',
  'slider slide',
  'slide',
  'control',
  'interface',
  'ui',
  'navigation',
  'panel',
];

ElementSliderSlideIcon.category = 'Navigator';

ElementSliderSlideIcon.iconSize = 16;
